import React, { CSSProperties } from 'react';
import { useSelector } from 'react-redux';

import { ShortcutAction, KEYBOARD_SHORTCUTS } from 'constants/shortcuts';
import { getIsShortcutActionAllowed } from 'reducers/cafaConfigs';

const defaultStyle: CSSProperties = {
  top: '5px',
  left: '8px',
  position: 'absolute',
};

export function KeyboardShortcut({
  shortcutAction,
  className,
  extraStyles,
  onClick,
}: {
  shortcutAction: ShortcutAction;
  className?: string;
  extraStyles?: CSSProperties;
  onClick?: (event: any) => void;
}) {
  const shortcutAllowed = useSelector(
    getIsShortcutActionAllowed(shortcutAction),
  );

  if (!shortcutAllowed) {
    return null;
  }

  const shortcutKey = KEYBOARD_SHORTCUTS[shortcutAction];
  const textToShow = shortcutKey === 'Escape' ? 'Esc' : shortcutKey;

  const style = { ...defaultStyle, ...(extraStyles ?? {}) };
  return (
    <span style={style} className={className} onClick={onClick}>
      {textToShow}
    </span>
  );
}
